/* eslint-disable no-plusplus */
import { SaltDocument } from '../SaltDocument';

const imagePickerTemplate = require('./imagePicker_simple.json');

class ImagePickerTranspiler {
    generateSalt(dialog) {
        const document = new SaltDocument(imagePickerTemplate);
        const viewEl = document.getByExpr('**.view');
        document.singleSelectNode(viewEl);
        // @TODO alias, viewAlias - we may want to allow salt to also reference user defined aliases
        const { view } = dialog;
        const viewId = SaltDocument.getViewId(view);
        document.setAttribute('id', viewId);
        return document.rootNode;
    }
}

const imagePickerTranspiler = new ImagePickerTranspiler();
export default imagePickerTranspiler;
